<template>
  <base-button type="submit" class="btn-primary" text="確認" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'ConfirmButton',
  components: {
    BaseButton,
  },
}
</script>
